import React, { useEffect, useMemo, useState } from "react";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { adobeData, formattedNumber, generateAdobeDataHorseName, generateAdobeDataRaceNo } from "@/app/utils/Common";
import styled from "styled-components";
import { Table, TableHead, TableCell, TableRow, TableBody } from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import _ from 'lodash';
import { GET_HORSE_PERFORMANCE, GET_HORSE_PROFILE } from "@/app/utils/request/query";
import { getHorsePerformance, getMeetingCountryAndHorseStatus} from "@/app/utils/request/requestList";
import { useLanguage } from "@/app/utils/LanguageContext";
import { textSize, text_size } from "@/app/utils/MixinSize"; 
import { useMyContext } from "@/app/utils/MyContext";
import { formattedDate, toDate } from "@/app/utils/DayJS";

const Container = styled.div`
  display: flex;
  padding: 12px 15px 12px 10%;
  border-radius: 4px 4px 0 0;
  background: #FFFFFF;
  justify-content: space-between;
`;
const MContainer = styled(TableContainer)` 
  border-radius:0 0 4px 4px;
  background: #FFFFFF;
  .viewSty {
    height: 44px;
    border-top: 1px solid #B4B4B4;
    align-items: center;
    padding-right: 8px;
  }
`;
const StyledDivL = styled.div`
  display: flex;
  width: calc(100% - 200px);
`;
const StyledDivR = styled.div`
display: flex;
align-items: baseline;
width: 200px;
justify-content: flex-end;
${text_size(11)}
font-weight: 400;
p {
  background: #E2EDF6;
  height: 28px;
  // width: 149px;
  border-radius: 100px;
  line-height: 28px;
  text-align: center;
  display: flex;
  margin-left: 5px;
  padding: 2px 2px;
  span {
    border-radius: 100px;
    line-height: 24px;
    cursor: pointer;
    ${text_size(11)}
    font-weight: 500;
  }
  span.checked {
    color: #FFFFFF;
    background: #2655CC;
    font-weight: 700;
  }

  span:first-child {
    // width: 86px;
    /* display: inline-block; */
    padding: 0 8px;
  }

  span:last-child {
    // width: 62px;
    padding: 0 8px;
    margin-left: 4px;
  }
}
`;

const StyledDivCol = styled.div`
  width: 25%;
  border-right: 1px solid #B4B4B4;
  margin-right: 12px;

  &:last-child {
    border-right: none;
  }

  p {
    display: flex;
  }
`;
 
const StyledItemFirst = styled.span`
  width: 55px;
  @media only screen and (min-width: 1680px) {
    width: 66.78px;
  }
  margin-right: 8px;
  color: #122C68;
  flex-shrink: 0;
  ${text_size(13)}
  font-weight: 300;
`;
const StyledItemSecond = styled.span`
  ${text_size(13)}
  font-weight: 500;
  color: #000000;
`;
const StyledTableCell = styled(TableCell)`
  padding: 0;
  &.${tableCellClasses.head} {
    width: 16.5%;
    height: 36px;
    ${text_size(11)}
    font-weight: 400;
    background: var(--Secondary, #6176A0);
    color: #fff;
    text-align: center;
    border-bottom: none;
    &:first-child{
      width: 33%;
    }
  }
  &.${tableCellClasses.body} {
    height: 33px;
    line-height: 33px;
    ${text_size(13)}
    font-weight: 500;
    text-align: center;
  }
  &.title {
    height: 36px;
    line-height: 36px;
    background: var(--Label-grey, #E1E1E1);
    color: #000000;
    font-weight: 500;
  }
  &:first-child {
    padding-left: 8px;
    text-align: left;
  }
`;

const StyledTableRow = styled(TableRow)<{ noneBorder?: boolean }>(({ noneBorder }) => ({
  '&': {
    borderBottom: noneBorder ? 0 : "1px solid #cccccc",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: "rgba(255, 255, 255, 1)",
  }
}));
  
export default function RaceCardPerformance(props: any) {
  const { state: lang } = useLanguage();
  const { t } = lang;
  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  //const venueCode = myContextState.selectedMeetingVenueCode;
  const [viewType, setViewType] = useState("Number");
  const [preformanceData, setPreformanceData] = useState<any>();
  const [curPreformanceData, setCurPreformanceData] = useState<any>();
  const [earings, setEarings] = useState<string>();
  const [season, setSeason] = useState<string>();

  const meetingDate = props.page != "horseInfo" ? myContextState.selectedMeetingDate : props.meetingDate ;
  const venueCode = props.page != "horseInfo" ? myContextState.selectedMeetingVenueCode : props?.meetingVenueCode;
  const raceNo = props.page != "horseInfo" ? myContextState.selectedRaceNo.valueOf() : props?.raceNo.valueOf();
 
  const countryList = ["AUS", "NZ", "MAC", "SAF"]
  const getSeason = (country: string) => {
    const meetingDT= props.page != "horseInfo" ? myContextState.selectedMeetingDate : toDate(props.meetingDate, "YYYYMMDD", true); 
    if(countryList.includes(country) && meetingDT){
      const seasonEndDate = new Date(meetingDT.getFullYear(), 7, 31);
      if(meetingDT <= seasonEndDate) {
        const prevYear = meetingDT.getFullYear() - 1;
        const currYear = meetingDT.getFullYear() % 100;
        return `${prevYear}/${currYear}`
      }else {
        
        const currYear = meetingDT.getFullYear();
        const nextYear = (meetingDT.getFullYear() + 1) % 100;
        return `${currYear}/${nextYear}`
      }
    }else {
      return meetingDT ? meetingDT.getFullYear().toString() : ""
    }
  }
  useEffect(() => {
    console.log("meetingCountry", props.raceCountry, props.meetingDate, countryList)
    const seasonVal =  getSeason(props.raceCountry);
    setSeason(seasonVal);
  }, [props.raceCountry]);

  useEffect(() => {  
    // from horse profile
    if (props.page == "horseInfo") {       
      const newData: any = {
        percentage: {},
        number: {}
      }
      const data = props?.data?.performanceStats; 
      data?.forEach((item: any) => {
        const { percentage, number } = initPreformance(item);
        newData.percentage[item.type] = percentage;
        newData.number[item.type] = number;
      });
      setPreformanceData(newData);
      setCurPreformanceData(newData?.number);
    }
  }, [props.data?.performanceStats]);

  useEffect(() => {
    if (props.page != "horseInfo") {
      const newData: any = {
        percentage: {},
        number: {}
      }
      const data = props.data?.performanceStats;

      setEarings(formattedNumber(props.data?.earings))
      data?.forEach((item: any) => {
        const { percentage, number } = initPreformance(item);
        newData.percentage[item.type] = percentage;
        newData.number[item.type] = number;
      });

      setPreformanceData(newData);
      setCurPreformanceData(newData?.number);
    }
  }, []);

  const initPreformance = (item: any) => {
    const totalRun = Number(item?.totalRun ?? -1);
    const firstPer = totalRun > 0 ? ((Number(item?.firstPlace ?? 0) / Number(item?.totalRun ?? 0)) * 100).toFixed(0) : 0;
    const secondPre = totalRun > 0 ? ((Number(item?.secondPlace ?? 0) / Number(item?.totalRun ?? 0)) * 100).toFixed(0) : 0;
    const thirdPre = totalRun > 0 ? ((Number(item?.thirdPlace ?? 0) / Number(item?.totalRun ?? 0)) * 100).toFixed(0) : 0;
    const percentage = {
      totalRun: totalRun.toString(),
      firstPlace: totalRun >= 0 ? firstPer + "%" : '-',
      secondPlace: totalRun >= 0 ? secondPre + "%" : '-',
      thirdPlace: totalRun >= 0 ? thirdPre + "%" : '-',
      season: item.type == "Season" ? item?.ssn : ""
    }
    const number = {
      totalRun: Number(item?.totalRun ?? -1),
      firstPlace: Number(item?.firstPlace ?? -1),
      secondPlace: Number(item?.secondPlace ?? -1),
      thirdPlace: Number(item?.thirdPlace ?? -1),
      season: item.type == "Season" ? item?.ssn : ""
    }
    return { percentage, number }
  }
  console.log("curPreformanceData", curPreformanceData)

  const onClickPercentage = () => { 
    setViewType("Percentage");
    setCurPreformanceData(preformanceData.percentage); 
    adobeData(lang.langCode == "en-us" ? "en" : "zh-hk", "interaction", {
      pageId: "racing/simulcast",
      eventId: `racing/simulcast_Click_${props?.page == "horseInfo" ? "HorseProfile" : "RaceCard"}_ViewOption`,
      raceNo: generateAdobeDataRaceNo(meetingDate, venueCode, raceNo),
      buttonName: "racing/simulcast_Click_Percentage",
      horse: generateAdobeDataHorseName(meetingDate, venueCode, props.horseName),
    })
  }
  const onClickNumber = () => {
    setViewType("Number");
    setCurPreformanceData(preformanceData.number); 
    adobeData(lang.langCode == "en-us" ? "en" : "zh-hk", "interaction", {
      pageId: "racing/simulcast",
      eventId: `racing/simulcast_Click_${props?.page == "horseInfo" ? "HorseProfile" : "RaceCard"}_ViewOption`,
      raceNo: generateAdobeDataRaceNo(meetingDate, venueCode, raceNo),
      buttonName: "racing/simulcast_Click_Number",
      horse: generateAdobeDataHorseName(meetingDate, venueCode, props.horseName),
    })
  }

  const handledContent = (item: any) => {
    if (item?.totalRun >= 0) {
      return `${item?.totalRun} (${item?.firstPlace}-${item?.secondPlace}-${item?.thirdPlace})`
    }
    else {
      return '-'
    }
  }
  const handledContentMobile = (val: string) => {
    if (val || Number(val ?? -1) >= 0) {
      return val
    } else {
      return '-'
    }
  }

  return props.type === "pc" ? (
    <Container className="performance">
      <StyledDivL id="horse_profile_pc_RaceCardPerformance_Styled">
        <StyledDivCol>
          <p>
            <StyledItemFirst>{season}</StyledItemFirst>
            <StyledItemSecond>{handledContent(curPreformanceData?.Season)} </StyledItemSecond>
          </p>
          <p>
            <StyledItemFirst>{t("race_card_1stUp")}</StyledItemFirst>
            <StyledItemSecond>{handledContent(curPreformanceData?.FirstUp)}</StyledItemSecond>
          </p>
          {props.page != "horseInfo" ? (
            <p>
              <StyledItemFirst>{t("race_card_earnings")}</StyledItemFirst>
              <StyledItemSecond>{earings ? 'HK$' + earings : '-'}</StyledItemSecond>
            </p>
          ) : ''}

        </StyledDivCol>
        <StyledDivCol>
          <p>
            <StyledItemFirst>{t("race_card_turf")}</StyledItemFirst>
            <StyledItemSecond>{handledContent(curPreformanceData?.Turf)}</StyledItemSecond>
          </p>
          <p>
            <StyledItemFirst>{t("race_card_nonTurf")}</StyledItemFirst>
            <StyledItemSecond>{handledContent(curPreformanceData?.NonTurf)}</StyledItemSecond>
          </p>
        </StyledDivCol>
        <StyledDivCol>
          <p>
            <StyledItemFirst>{t("race_card_dist")}</StyledItemFirst>
            <StyledItemSecond>{handledContent(curPreformanceData?.Dist)}</StyledItemSecond>
          </p>
          <p>
            <StyledItemFirst>{t("race_card_performance_track")}</StyledItemFirst>
            <StyledItemSecond>{handledContent(curPreformanceData?.Trk)}</StyledItemSecond>
          </p>
          <p>
            <StyledItemFirst>{t("race_card_trk_dist")}</StyledItemFirst>
            <StyledItemSecond>{handledContent(curPreformanceData?.TrkDist)}</StyledItemSecond>
          </p>
          <p>
            <StyledItemFirst>{t("race_card_nhRules")}</StyledItemFirst>
            <StyledItemSecond>{handledContent(curPreformanceData?.Hurdle)}</StyledItemSecond>
          </p>
        </StyledDivCol>
        <StyledDivCol>
          <p>
            <StyledItemFirst>{t("race_card_gf")}</StyledItemFirst>
            <StyledItemSecond>{handledContent(curPreformanceData?.Firm)}</StyledItemSecond>
          </p>
          <p>
            <StyledItemFirst>{t("race_card_g")}</StyledItemFirst>
            <StyledItemSecond>{handledContent(curPreformanceData?.Good)}</StyledItemSecond>
          </p>
          <p>
            <StyledItemFirst>{t("race_card_y")}</StyledItemFirst>
            <StyledItemSecond>{handledContent(curPreformanceData?.Yield)}</StyledItemSecond>
          </p>
          <p>
            <StyledItemFirst>{t("race_card_s_hvy")}</StyledItemFirst>
            <StyledItemSecond>{handledContent(curPreformanceData?.SoftHeavy)}</StyledItemSecond>
          </p>
        </StyledDivCol>
      </StyledDivL>
      <StyledDivR style={{whiteSpace: "nowrap"}}>
        {t("race_card_view_in")}
        <p>
          <span onClick={onClickPercentage} className={viewType == "Percentage" ? "checked" : ""}>{t("race_card_percentage")}</span>
          <span onClick={onClickNumber} className={viewType == "Number" ? "checked" : ""}>{t("race_card_number")}</span>
        </p>
      </StyledDivR>
    </Container>
  ) : (
    <MContainer className="mPerformance">
      <StyledDivR className="viewSty" style={{ justifyContent: "end", width: "100%", }}>
        {t("race_card_view_in")}
        <p>
          <span onClick={onClickPercentage} className={viewType == "Percentage" ? "checked" : ""}>{t("race_card_percentage")}</span>
          <span onClick={onClickNumber} className={viewType == "Number" ? "checked" : ""}>{t("race_card_number")}</span>
        </p>
      </StyledDivR>

      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell>{t("race_card_run")}</StyledTableCell>
            <StyledTableCell>{t("race_card_win")}</StyledTableCell>
            <StyledTableCell>{t("race_card_2nd")}</StyledTableCell>
            <StyledTableCell>{t("race_card_3rd")}</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <StyledTableRow noneBorder>
            <StyledTableCell className="title" colSpan={5}>{t("race_card_by_going")}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t("race_card_good_to_firm")}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Firm?.totalRun)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Firm?.firstPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Firm?.secondPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Firm?.thirdPlace)}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t("race_card_good")}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Good?.totalRun)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Good?.firstPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Good?.secondPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Good?.thirdPlace)}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t("race_card_yielding")}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Yield?.totalRun)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Yield?.firstPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Yield?.secondPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Yield?.thirdPlace)}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow noneBorder>
            <StyledTableCell>{t("race_card_soft_heavy")}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.SoftHeavy?.totalRun)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.SoftHeavy?.firstPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.SoftHeavy?.secondPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.SoftHeavy?.thirdPlace)}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow noneBorder>
            <StyledTableCell className="title" colSpan={5}>{t("race_card_by_course")}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t("race_card_turf")}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Turf?.totalRun)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Turf?.firstPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Turf?.secondPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Turf?.thirdPlace)}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t("race_card_nonTurf")}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.NonTurf?.totalRun)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.NonTurf?.firstPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.NonTurf?.secondPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.NonTurf?.thirdPlace)}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow noneBorder>
            <StyledTableCell>{t("race_card_nhRules")}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Hurdle?.totalRun)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Hurdle?.firstPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Hurdle?.secondPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Hurdle?.thirdPlace)}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow noneBorder>
            <StyledTableCell className="title" colSpan={5}>{t("race_card_by_distance_track")}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t("race_card_distance")}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Dist?.totalRun)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Dist?.firstPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Dist?.secondPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Dist?.thirdPlace)}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t("race_card_performance_track")}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Trk?.totalRun)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Trk?.firstPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Trk?.secondPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Trk?.thirdPlace)}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t("race_card_track_distance")}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.TrkDist?.totalRun)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.TrkDist?.firstPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.TrkDist?.secondPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.TrkDist?.thirdPlace)}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow noneBorder>
            <StyledTableCell className="title" colSpan={5}>{t("race_card_by_season")}</StyledTableCell>
          </StyledTableRow>
          <StyledTableRow noneBorder>
            <StyledTableCell>{season}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Season?.totalRun)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Season?.firstPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Season?.secondPlace)}</StyledTableCell>
            <StyledTableCell>{handledContentMobile(curPreformanceData?.Season?.thirdPlace)}</StyledTableCell>
          </StyledTableRow>
        </TableBody>
      </Table>

    </MContainer>
  );
}
